// Añadir este código a tu archivo JavaScript o al final de tu HTML

document.addEventListener('DOMContentLoaded', function() {
  // Función para el botón Show All de categorías
  function initCategoryShowMore() {
    const showMoreButton = document.querySelector('.collection-categories__show-more');
    if (!showMoreButton) return;
    
    // Limpiar eventos previos
    const newButton = showMoreButton.cloneNode(true);
    showMoreButton.parentNode.replaceChild(newButton, showMoreButton);
    
    // Agregar nuevo evento
    newButton.addEventListener('click', function() {
      const hiddenItems = document.querySelectorAll('.collection-categories__item--hidden');
      const isExpanded = this.classList.contains('active');
      
      hiddenItems.forEach(item => {
        item.classList.toggle('show');
      });
      
      this.classList.toggle('active');
      
      // Actualizar texto
      const buttonSpan = this.querySelector('span');
      if (buttonSpan) {
        buttonSpan.textContent = isExpanded ? 'Show All' : 'Show Less';
      }
    });
  }
  
  // Inicializar botón Show All
  initCategoryShowMore();
  
  // Para filtros: Forzar que todos los details estén abiertos
  function expandAllFilters() {
    const filterDetails = document.querySelectorAll('.facets__disclosure-vertical');
    filterDetails.forEach(detail => {
      detail.setAttribute('open', 'true');
    });
  }
  
  // Llamar a esta función inicialmente y después de cargar la página
  expandAllFilters();
  
  
});
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    // Add event listeners for form inputs to trigger full page refresh
    const facetForm = this.querySelector('form');
    if (facetForm) {
      // Listen for changes on checkboxes, selects, and other form inputs
      facetForm.addEventListener('change', (event) => {
        // Small delay to allow the input to update
        setTimeout(() => {
          this.onSubmitHandler(event);
        }, 100);
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.bindShowMoreButtons();
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    // Use full page refresh instead of AJAX updates
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      // For mobile checkboxes, submit the form directly
      const form = event.target.closest('form');
      if (form) {
        form.submit();
      }
    } else {
      // For other form elements, submit the main form
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      
      // Build the URL with search parameters and navigate to it
      const searchParams = forms.join('&');
      const currentUrl = window.location.pathname;
      const newUrl = searchParams ? `${currentUrl}?${searchParams}` : currentUrl;
      window.location.href = newUrl;
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    // Use full page refresh instead of AJAX
    const currentUrl = window.location.pathname;
    const newUrl = url ? `${currentUrl}?${url}` : currentUrl;
    window.location.href = newUrl;
  }

  bindShowMoreButtons() {
    const showMoreButtons = document.querySelectorAll('.facets__show-more');
    showMoreButtons.forEach(button => {
      button.addEventListener('click', this.onShowMoreClick.bind(this));
    });
  }

  onShowMoreClick(event) {
    const button = event.currentTarget;
    const list = button.closest('.facets__display-vertical').querySelector('.facets__list-vertical');
    const hiddenItems = list.querySelectorAll('.facets__item.hidden');
    const buttonText = button.querySelector('span');
    const isExpanded = button.classList.contains('active');

    hiddenItems.forEach(item => {
      item.classList.toggle('show');
    });

    button.classList.toggle('active');
    buttonText.textContent = isExpanded ? 'Show All' : 'Show Less';
  }
}

// Static variables removed since we're using full page refreshes
// FacetFiltersForm.filterData = [];
// FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) {
      return;
    }
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (!form || typeof form.onActiveFilterClick !== 'function') {
      return;
    }
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class CollectionCategories {
  constructor() {
    this.showMoreButton = document.querySelector('.collection-categories__show-more');
    this.hiddenItems = document.querySelectorAll('.collection-categories__item--hidden');
    
    if (this.showMoreButton) {
      this.showMoreButton.addEventListener('click', this.toggleCategories.bind(this));
      this.isExpanded = false;
    }
  }

  toggleCategories() {
    this.hiddenItems.forEach(item => {
      item.classList.toggle('show');
    });
    
    this.isExpanded = !this.isExpanded;
    const buttonText = this.showMoreButton.querySelector('span');
    buttonText.textContent = this.isExpanded ? 'Show Less' : 'Show All';
    this.showMoreButton.classList.toggle('active');
  }
}

// Initialize the collection categories functionality
document.addEventListener('DOMContentLoaded', () => {
  new CollectionCategories();
});

document.addEventListener('DOMContentLoaded', () => {
  // Reorganizar estructura de filtros para que coincida con categorías
  function reorganizeFilters() {
    const checkboxLabels = document.querySelectorAll('.facets__list--vertical .facets__label');
    
    checkboxLabels.forEach(label => {
      // Reorganiza el contenido del checkbox
      const checkboxText = label.querySelector('.facet-checkbox__text');
      if (checkboxText) {
        const textContent = checkboxText.innerHTML;
        const labelText = textContent.split('(')[0].trim();
        const count = textContent.match(/\((\d+)\)/);
        
        if (count) {
          checkboxText.innerHTML = `
            <span class="facet-checkbox__text-label">${labelText}</span>
            <span class="facet-checkbox__count">${count[1]}</span>
          `;
        }
      }
    });
  }
  
  // Ejecutar después de un breve retraso para asegurar que el DOM está completamente cargado
  setTimeout(reorganizeFilters, 100);
  
  // También ejecutar cuando cambie el DOM (para filtros dinámicos)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        reorganizeFilters();
      }
    });
  });
  
  const facetsContainer = document.querySelector('.facets-container');
  if (facetsContainer) {
    observer.observe(facetsContainer, { childList: true, subtree: true });
  }
});

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.button-show-more');
    this.parentDetails = this.closest('details');
    if (!this.parentDetails) {
      this.hiddenItems = [];
      return;
    }
    this.hiddenItems = this.parentDetails.querySelectorAll('.show-more-item');
    
    if (this.button) {
      this.button.addEventListener('click', this.toggleItems.bind(this));
      this.isExpanded = false;
      
      // Set ARIA attributes for accessibility
      this.button.setAttribute('aria-expanded', 'false');
      const detailsId = this.parentDetails.id || '';
      if (detailsId) {
        this.button.setAttribute('aria-controls', `hidden-items-${detailsId}`);
      }
    }
  }

  toggleItems() {
    if (!this.button || !this.parentDetails) {
      return;
    }
    this.hiddenItems.forEach(item => {
      item.classList.toggle('show');
    });
    
    this.isExpanded = !this.isExpanded;
    this.button.setAttribute('aria-expanded', this.isExpanded.toString());
    
    const showMoreLabel = this.button.querySelector('.label-show-more');
    const showLessLabel = this.button.querySelector('.label-show-less');
    
    if (showMoreLabel && showLessLabel) {
      showMoreLabel.classList.toggle('hidden');
      showLessLabel.classList.toggle('hidden');
    }
  }
}

// Registrar el componente personalizado
customElements.define('show-more-button', ShowMoreButton);

// Inicializar tanto las categorías como los filtros
document.addEventListener('DOMContentLoaded', () => {
  // Inicializar categorías de colección
  new CollectionCategories();
  
  // Asegurar que los botones de show-more en los filtros tengan
  // el mismo comportamiento visual que las categorías
  document.querySelectorAll('.button-show-more').forEach(button => {
    button.addEventListener('click', function() {
      // Aplicar clase active para la rotación del ícono
      this.classList.toggle('active');
    });
  });
});
